/* eslint-disable @typescript-eslint/no-empty-function */
import React from "react";
type ContextType = {
  mobile: boolean;
  handleClose: () => void;
}
const MobileOpenContext = React.createContext({ mobile: false, handleClose: () => {} });

export const useMobileOpen = () => {
  const context = React.useContext(MobileOpenContext);
  if (!context) {
    throw new Error("useMobileOpen must be used within a MobileOpenProvider");
  }
  return context;
};

export const MobileOpenProvider = (props: any) => {
  const [mobileOpen, useMobile] = React.useState<ContextType>({
    mobile: false, handleClose: () => {},
  });
  const value = React.useMemo(() => [mobileOpen, useMobile], [mobileOpen]);
  return <MobileOpenContext.Provider value={value} {...props} />;
};
